import React, { useState, useEffect, useContext } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Alert from "@mui/material/Alert";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import Autocomplete from "@mui/material/Autocomplete";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import axios from "axios";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import DownloadExcelButton from "components/ReportUI/Downloadexcelbutton";
import MDSnackbar from "components/MDSnackbar";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";




import VehicleReportTable from "./vehiclereporttable";
import { vehiclereportendpoint } from "config";
import OverSpeedTable from "./overspeedCell";
import { DialogActions } from "@mui/material";
import { AccountsContext } from "context/AccountsContext";


function VehicleReport() {
  const [reportData, setReportData] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [successSB, setSuccessSB] = useState(false);
  const [errorSB, setErrorSB] = useState(false);
  const [loading, setLoading] = useState(false);
  const [date, setDate] = useState(new Date());
  const [selectedRow, setSelectedRow] = useState(null);
const [stopDetails, setStopDetails] = useState([]);


  const { fetchThings } = useContext(AccountsContext);

  useEffect(() => {
    fetchThings();
  }, []);

  // Snackbar handlers
  const openSuccessSB = () => setSuccessSB(true);
  const closeSuccessSB = () => setSuccessSB(false);
  const openErrorSB = () => setErrorSB(true);
  const closeErrorSB = () => setErrorSB(false);

  // Columns for Vehicle Report
  const columns = [
    { Header: "Date", accessor: "dateRange", width: "10%" },
    { Header: "Vehicle Number", accessor: "thingId", width: "15%" },
    { Header: "Vehicle Name", accessor: "thingName", width: "15%" },
    {
      Header: "Distance travelled (Km)",
      accessor: "totalDistance",
      Cell: ({ value }) => (value ? (value / 1000).toFixed(2) : "0.00"),
    },
    {
      Header: "Running Time (Hr:Min)",
      accessor: "runningTime",
      Cell: ({ value }) => {
        if (!value) return "00:00";
        const hours = Math.floor(value / 3600);
        const minutes = Math.floor((value % 3600) / 60);
        return `${hours.toString().padStart(2, "0")}:${minutes
          .toString()
          .padStart(2, "0")}`;
      },
    },
    {
      Header: "Speed Limit",
      accessor: "speedLimit",
      Cell: ({ value }) => (value ? (value * 3.6).toFixed(2) : "0.00"),
    },
    
 
    {
        Header: "Over Speed Percent",
        accessor: "overSpeedPercent",
        /* eslint-disable react/prop-types */
        Cell: ({ value, row }) => (
          <span
            style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}
            onClick={() => {
              setSelectedRow(row.original);
              setStopDetails(row.original.overSpeedSpots || []);
            }}
          >
            {value?.toFixed(2)} %
          </span>
        ),
        /* eslint-enable react/prop-types */
      },
      
      
    {
      Header: "Max Speed (Km/hr)",
      accessor: "maxSpeed",
      Cell: ({ value }) => (value ? (value * 3.6).toFixed(2) : "0.00"),
    },
    {
      Header: "Idle Time (Hr:Min)",
      accessor: "idleTime",
      Cell: ({ value }) => {
        if (!value) return "00:00";
        const hours = Math.floor(value / 3600);
        const minutes = Math.floor((value % 3600) / 60);
        return `${hours.toString().padStart(2, "0")}:${minutes
          .toString()
          .padStart(2, "0")}`;
      },
    },
    {
        Header: "Park time (Hr:Min)",
        accessor: "parkedTime",
        Cell: ({ value }) => {
          if (!value) return "00:00";
          const hours = Math.floor(value / 3600);
          const minutes = Math.floor((value % 3600) / 60);
          return `${hours.toString().padStart(2, "0")}:${minutes
            .toString()
            .padStart(2, "0")}`;
        },
      },
      { Header: "Ignition Status", accessor: "ignStatus", width: "15%" },
      {
        Header: " Toeing Time (Hr:Min)",
        accessor: "toeingTimee",
        Cell: ({ value }) => {
          if (!value) return "00:00";
          const hours = Math.floor(value / 3600);
          const minutes = Math.floor((value % 3600) / 60);
          return `${hours.toString().padStart(2, "0")}:${minutes
            .toString()
            .padStart(2, "0")}`;
        },
      },
      { Header: "Last Updated At", accessor: "lastUpdatedAt", width: "15%" },
  ];

  // Format date to API format
  const formatDate = (d) => {
    const pad = (n) => String(n).padStart(2, "0");
    return `${d.getFullYear()}/${pad(d.getMonth() + 1)}/${pad(d.getDate())}`;
  };

  const stopColumns = [
    { Header: "Timestamp", accessor: "timestamp" },
    {
      Header: "Location",
      accessor: "locationName",
      Cell: ({ value }) => (
        <a href={value} target="_blank" rel="noopener noreferrer">
          {value}
        </a>
      ),
    },
    {
      Header: "Speed (Km/hr)",
      accessor: "averageSpeed",
    
    },
    {
      Header: "Duration (Hr:Min:Sec)",
      accessor: "timeOverSpeed",
      Cell: ({ value }) => {
        if (!value) return "00:00:00";
        const hours = Math.floor(value / 3600);
        const minutes = Math.floor((value % 3600) / 60);
        const seconds = value % 60;
        return `${hours.toString().padStart(2, "0")}:${minutes
          .toString()
          .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
      },
    },
  ];
  
  const fetchReport = async () => {
    const token = localStorage.getItem("token");
    setLoading(true);
    setErrorMessage("");

    try {
      const data = {
        date: formatDate(date),
        zone: "Asia/Kolkata",
        startTime: `${formatDate(date)} 00:00`,
        endTime: `${formatDate(date)} 23:59`,
        things: "",
        thingIds: [],
        geofence: [],
        groups: [],
        interval: 0,
        orgName: "",
        geoFenceName: "",
        geoLat: 0,
        geoLong: 0,
        dayRange: 0,
      };

      const config = {
        method: "post",
        url:vehiclereportendpoint,
        headers: {
          "x-dhundhoo-session": token,
          "Content-Type": "application/json",
        },
        data,
      };

      const response = await axios.request(config);
      setReportData(response.data.list || []);
      openSuccessSB();
    } catch (error) {
      console.error(error);
      setErrorMessage("Error loading vehicle report");
      openErrorSB();
    } finally {
      setLoading(false);
    }
  };

  const clearFilters = () => {
    setReportData([]);
    setErrorMessage("");
    setDate(new Date());
  };

  const exportToCSV = () => {
    if (reportData.length === 0) {
      setErrorMessage("No data to export");
      openErrorSB();
      return;
    }
  
    const headers = [
      "Date",
      "Vehicle Number",
      "Vehicle Name",
      "Distance Travelled (Km)",
      "Running Time (Hr:Min)",
      "Speed Limit (Km/hr)",
      "Over Speed Percent",
      "Max Speed (Km/hr)",
      "Idle Time (Hr:Min)",
      "Park Time (Hr:Min)",
      "Ignition Status",
      "Toeing Time (Hr:Min)",
      "Last Updated At",
    ];
  
    const rows = reportData.map((row) => [
      row.dateRange,
      row.thingId,
      row.thingName,
  
      // Distance in Km
      row.totalDistance ? (row.totalDistance / 1000).toFixed(2) : "0.00",
  
      // Running Time
      (() => {
        if (!row.runningTime) return "00:00";
        const hours = Math.floor(row.runningTime / 3600);
        const minutes = Math.floor((row.runningTime % 3600) / 60);
        return `${hours.toString().padStart(2, "0")}:${minutes
          .toString()
          .padStart(2, "0")}`;
      })(),
  
      // Speed Limit in Km/hr
      row.speedLimit ? (row.speedLimit * 3.6).toFixed(2) : "0.00",
  
      // Over Speed %
      row.overSpeedPercent ? row.overSpeedPercent.toFixed(2) + " %" : "0.00 %",
  
      // Max Speed in Km/hr
      row.maxSpeed ? (row.maxSpeed * 3.6).toFixed(2) : "0.00",
  
      // Idle Time
      (() => {
        if (!row.idleTime) return "00:00";
        const hours = Math.floor(row.idleTime / 3600);
        const minutes = Math.floor((row.idleTime % 3600) / 60);
        return `${hours.toString().padStart(2, "0")}:${minutes
          .toString()
          .padStart(2, "0")}`;
      })(),
  
      // Park Time
      (() => {
        if (!row.parkedTime) return "00:00";
        const hours = Math.floor(row.parkedTime / 3600);
        const minutes = Math.floor((row.parkedTime % 3600) / 60);
        return `${hours.toString().padStart(2, "0")}:${minutes
          .toString()
          .padStart(2, "0")}`;
      })(),
  
      row.ignStatus || "",
  
      // Toeing Time
      (() => {
        if (!row.toeingTimee) return "00:00";
        const hours = Math.floor(row.toeingTimee / 3600);
        const minutes = Math.floor((row.toeingTimee % 3600) / 60);
        return `${hours.toString().padStart(2, "0")}:${minutes
          .toString()
          .padStart(2, "0")}`;
      })(),
  
      row.lastUpdatedAt || "",
    ]);
  
    const csvContent = [headers.join(","), ...rows.map((r) => r.join(","))].join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", `VehicleReport.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox p={3} pb={0}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <Grid container spacing={2}>
                    {/* Date Picker */}
                    <Grid item xs={12} sm={6} md={3}>
                      <DatePicker
                        label="Select Date"
                        value={date}
                        onChange={(newValue) => setDate(newValue)}
                        renderInput={(params) => <TextField {...params} fullWidth size="small" />}
                      />
                    </Grid>

                    {/* Buttons */}
                    <Grid item xs={4} sm={2} md={1}>
                      <MDButton
                        fullWidth
                        variant="gradient"
                        color="info"
                        size="small"
                        onClick={fetchReport}
                        disabled={loading}
                      >
                        {loading ? <CircularProgress size={20} color="inherit" /> : "LOAD"}
                      </MDButton>
                    </Grid>
                    <Grid item xs={4} sm={2} md={1}>
                      <DownloadExcelButton fullWidth label="CSV" onClick={exportToCSV} disabled={loading} />
                    </Grid>

                    <Grid item xs={4} sm={2} md={1}>
                      <MDButton
                        fullWidth
                        variant="outlined"
                        color="error"
                        size="small"
                        onClick={clearFilters}
                        disabled={loading}
                      >
                        CLEAR
                      </MDButton>
                    </Grid>
                  </Grid>
                </LocalizationProvider>
              </MDBox>

              {/* Error Alert */}
              {errorMessage && (
                <MDBox px={2} pt={2}>
                  <Alert severity="error">{errorMessage}</Alert>
                </MDBox>
              )}

              {/* Loader or Table */}
              <MDBox pt={3} display="flex" justifyContent="center">
                {loading ? (
                  <CircularProgress />
                ) : (
                  <VehicleReportTable
                    table={{ columns, rows: reportData }}
                    isSorted={true}
                    entriesPerPage={false}
                    showTotalEntries={true}
                    noEndBorder
                    canSearch={true}
                  />
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Dialog open={!!selectedRow} onClose={() => setSelectedRow(null)} maxWidth="md" fullWidth>
  <DialogTitle>
    Vehicle Overspeed Info for {selectedRow?.thingName}
  </DialogTitle>

  <DialogContent>
    <OverSpeedTable
      table={{ columns: stopColumns, rows: stopDetails }}
      entriesPerPage={{ defaultValue: 5, entries: [5, 10, 20] }}
      canSearch
      showTotalEntries
      isSorted
      noEndBorder
      pagination={{ variant: "gradient", color: "info" }}
    />
  </DialogContent>

  <DialogActions>
    <MDButton onClick={() => setSelectedRow(null)} variant="contained" color="primary">
      Close
    </MDButton>
  </DialogActions>
</Dialog>

      {/* Snackbars */}
      <MDSnackbar
        color="success"
        icon="check"
        title="Vehicle Report"
        content="Data Loaded Successfully"
        open={successSB}
        onClose={closeSuccessSB}
        close={closeSuccessSB}
        bgWhite
      />
      <MDSnackbar
        color="error"
        icon="warning"
        title="Vehicle Report"
        content="Failed to load report"
        open={errorSB}
        onClose={closeErrorSB}
        close={closeErrorSB}
        bgWhite
      />
    </DashboardLayout>
  );
}

export default VehicleReport;
